











import TitleBar from '@/modules/core/components/TitleBar.vue';
import Tiles from '@/modules/core/components/Tiles.vue';
import CardWidget from '@/modules/core/components/CardWidget.vue';
import CardComponent from '@/modules/core/components/CardComponent.vue';
import AlertsTable from '../components/AlertsTable.vue';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    TitleBar,
    Tiles,
    CardWidget,
    CardComponent,
    AlertsTable,
  },
})
export default class AlertList extends Vue {
  public get titleStack(): string[] {
    return ['Admin', 'Alertes'];
  }
}
